import { render, staticRenderFns } from "./ViewTemplate.vue?vue&type=template&id=a4a800b0&scoped=true"
import script from "./ViewTemplate.vue?vue&type=script&lang=js"
export * from "./ViewTemplate.vue?vue&type=script&lang=js"
import style0 from "./ViewTemplate.vue?vue&type=style&index=0&id=a4a800b0&prod&lang=scss&scoped=true"
import style1 from "./ViewTemplate.vue?vue&type=style&index=1&id=a4a800b0&prod&lang=scss&scoped=true"
import style2 from "./ViewTemplate.vue?vue&type=style&index=2&id=a4a800b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a800b0",
  null
  
)

export default component.exports